import type { ComponentEditorMetaDataDefinition } from '../types';

const metaData: ComponentEditorMetaDataDefinition = {
  allowConnectToDB: true,
};

export default metaData;
